import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled, { ThemeProvider } from 'styled-components';
import darkTheme from 'themes/darkTheme';
import ButtonV2 from 'components/ButtonV2';
import Card from 'components/Card';
import AddressForm from '../components/AddressForm';
import ProgressHeader from '../components/ProgressHeader';
import { useSignup } from '../context/SignupContext';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
  padding: 32px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const CardSubtitle = styled.p`
  font-size: 15px;
  color: #94a3b8;
  margin: 0 0 32px 0;
  line-height: 1.6;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  button {
    width: auto;
    min-width: 140px;
    flex: 0 0 auto;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

const TrackAddressStep = () => {
  const { formData, updateField, errors, getTotalSteps, getStepNumber } =
    useSignup();
  const history = useHistory();

  const handleAddressChange = (field, value) => {
    updateField('track_address', {
      ...formData.track_address,
      [field]: value,
    });
  };

  const handleAddressSelect = (parsed) => {
    updateField('track_address', {
      ...formData.track_address,
      ...parsed,
    });
  };

  const isFormValid =
    formData.track_address?.street1 &&
    formData.track_address?.city &&
    formData.track_address?.state &&
    formData.track_address?.zipcode;

  const handleContinue = () => {
    const address = formData.track_address || {};

    // Validate required fields
    if (
      !address.street1 ||
      !address.city ||
      !address.state ||
      !address.zipcode
    ) {
      toast.error('Please fill in all required address fields');
      return;
    }

    // Navigate to next step
    history.push('/promoter-signup/shipping-address');
  };

  const handleBack = () => {
    history.push('/promoter-signup/business-details');
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <PageContainer>
        <ContentWrapper>
          <ProgressHeader
            currentStep={getStepNumber('/promoter-signup/track-address')}
            totalSteps={getTotalSteps()}
            stepTitle="Track Address"
          />

          <Card>
            <CardSubtitle>
              Enter the physical address of your track or venue.
            </CardSubtitle>

            <AddressForm
              address={formData.track_address || {}}
              onChange={handleAddressChange}
              onAddressSelect={handleAddressSelect}
              errors={errors.track_address || {}}
              idPrefix="track_"
            />

            <ButtonRow>
              <ButtonV2 onClick={handleBack}>← Back</ButtonV2>
              <ButtonV2
                onClick={handleContinue}
                disabled={!isFormValid}
                primary={!!isFormValid}
              >
                Continue →
              </ButtonV2>
            </ButtonRow>
          </Card>
        </ContentWrapper>
      </PageContainer>
    </ThemeProvider>
  );
};

export default TrackAddressStep;
